import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
  projectId: 'tjkd2lq3',
  dataset: 'production',
  apiVersion: '2022-02-01',
  useCdn: true,
  token: 'skAarwEsaLOw1fnDWyqlag4m4ZQmOaOwDjcsg0kXJvrOofXKjFh6Y7c2tg42ggxrOZm785ea1sGbJUDKnYaFHNLp6tshw7axasMwjKydnjQZylebc57JW3xIhjAv2rZooRAYZrx6LrRt5NsaDiU4n07MRdeYpOdVOMG3BBv7JTyKxnPGlKhB',
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);
